import React, { useState, useEffect, useMemo } from "react";

import "../styles/TransactionModal.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TransactionSuccessModal from "../components/TransactionSuccessModal";
import Select from "react-select";

import {
  Wallet,
  ArrowDownCircle,
  ArrowUpCircle,
  User,
  ShieldCheck,
  TrendingUp,
  CalendarDays,
  X,
  CheckCircle2,
  Activity,
} from "lucide-react";

import { toast } from "react-toastify";

import logo from "../assets/logo.png";

const API_BASE_URL =
  "https://client-management-backend-8x91.onrender.com";

const TransactionModal = ({
  onClose,
  refreshInvestors,
}) => {
  const [investors, setInvestors] = useState([]);

  const [selectedInvestor, setSelectedInvestor] =
    useState(null);

  const [selectedInvestorData, setSelectedInvestorData] =
    useState(null);

  const [transactionType, setTransactionType] =
    useState("Deposit");

  const [amount, setAmount] = useState("");

  const [transactionDate, setTransactionDate] =
    useState(new Date());

  const [processing, setProcessing] = useState(false);

  const [success, setSuccess] = useState(false);

  const [latestTransaction, setLatestTransaction] =
    useState(null);

  useEffect(() => {
    fetchInvestors();
  }, []);

  const fetchInvestors = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/investors`
      );

      const data = await response.json();

setInvestors(
  data
    .filter(
      (investor) =>
        investor.status?.trim().toLowerCase() ===
        "active"
    )
    .map((investor) => ({
      value: investor.id,
      label: `${investor.name} (${investor.account_number || "N/A"})`,
      investorData: investor,
    }))
);
    } catch (error) {
      console.error(error);
    }
  };

  const amountValue = parseFloat(amount || 0);

  const balanceBefore = parseFloat(
    selectedInvestorData?.account_balance || 0
  );

  const balanceAfter = useMemo(() => {
    if (!amountValue) return balanceBefore;

    return transactionType === "Deposit"
      ? balanceBefore + amountValue
      : balanceBefore - amountValue;
  }, [
    amountValue,
    balanceBefore,
    transactionType,
  ]);

  const currentBalance = parseFloat(
    selectedInvestorData?.current_balance || 0
  );

  const handleTransaction = async () => {
    if (
      !selectedInvestor ||
      !amount ||
      parseFloat(amount) <= 0
    ) {
      toast.warn(
        "Please complete all transaction details."
      );

      return;
    }

    try {
      setProcessing(true);

      await new Promise((resolve) =>
        setTimeout(resolve, 15000)
      );

      const transactionData = {
        investor_id: selectedInvestor.value,
        transaction_type: transactionType,
        amount: parseFloat(amount),
        transaction_date:
          transactionDate.toISOString(),
      };

      const response = await fetch(
        `${API_BASE_URL}/transactions/process`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(transactionData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();

        throw new Error(
          errorData.error || "Transaction failed"
        );
      }

      const investorResponse = await fetch(
        `${API_BASE_URL}/investors/${selectedInvestor.value}`
      );

      const updatedInvestor =
        await investorResponse.json();

      const finalBalance = parseFloat(
        updatedInvestor?.account_balance || 0
      );

      const finalCurrentBalance = parseFloat(
        updatedInvestor?.current_balance || 0
      );
setLatestTransaction({
  receiptNumber: Math.floor(
    100000 + Math.random() * 900000
  ),

  investorId: updatedInvestor.id,

  investorName: updatedInvestor.name,

  transactionType,

  amount: parseFloat(amount),

  balanceBefore,

  balanceAfter: finalBalance,

  availableBalance: finalBalance,

  currentBalance: finalCurrentBalance,

  transactionDate,
});
      if (updatedInvestor?.phone_number) {
        const smsMessage = `Hello ${updatedInvestor.name}, your ${transactionType.toLowerCase()} of $${parseFloat(amount).toFixed(2)} has been processed successfully. Your updated account balance is now $${finalBalance.toFixed(2)}. Thank you for choosing RCS Focus Finance.`;

        try {
          await fetch(`${API_BASE_URL}/sms/send`, {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              phoneNumber:
                updatedInvestor.phone_number,

              message: smsMessage,
            }),
          });
        } catch (smsError) {
          console.warn(smsError);
        }
      }


/* ✅ STOP LOADER */
setProcessing(false);

/* ✅ SMOOTH TRANSITION */
setTimeout(() => {
  setSuccess(true);
}, 250);

toast.success(
  "Transaction completed successfully."
);



    } catch (error) {
      console.error(error);

      toast.error(
        error.message || "Transaction failed."
      );

      setProcessing(false);
    }
  };

  const handlePrintReceipt = () => {
    const receiptWindow = window.open(
      "",
      "_blank",
      "width=800,height=900"
    );

    receiptWindow.document.write(`
      <html>
      <head>
        <title>Finance Receipt</title>

        <style>
          body{
            font-family:Arial;
            padding:40px;
            color:#071133;
          }

          .receipt{
            border:2px solid #14b8a6;
            border-radius:18px;
            padding:40px;
          }

          h1{
            margin:0;
            color:#071133;
          }

          h2{
            color:#14b8a6;
            margin-top:6px;
          }

          .section{
            margin-top:28px;
          }

          .row{
            display:flex;
            justify-content:space-between;
            margin-bottom:12px;
          }

          .footer{
            margin-top:50px;
            text-align:center;
            font-size:14px;
            color:#64748b;
          }
        </style>
      </head>

      <body>

        <div class="receipt">

          <h1>RCS TOPUP & BILLING ENTITY</h1>

          <h2>FOCUS FINANCE</h2>

          <div class="section">

            <div class="row">
              <strong>CLIENT ID</strong>
              <span>${latestTransaction.investorId}</span>
            </div>

            <div class="row">
              <strong>CLIENT NAME</strong>
              <span>${latestTransaction.investorName}</span>
            </div>

            <div class="row">
              <strong>TRANSACTION TYPE</strong>
              <span>${latestTransaction.transactionType}</span>
            </div>

            <div class="row">
              <strong>TRANSACTION DATE</strong>
              <span>${new Date(
                latestTransaction.transactionDate
              ).toLocaleString()}</span>
            </div>

          </div>

          <div class="section">

            <div class="row">
              <strong>BALANCE BEFORE</strong>
              <span>$${latestTransaction.balanceBefore.toLocaleString()}</span>
            </div>

            <div class="row">
              <strong>TRANSACTION AMOUNT</strong>
              <span>$${latestTransaction.amount.toLocaleString()}</span>
            </div>

            <div class="row">
              <strong>BALANCE AFTER</strong>
              <span>$${latestTransaction.balanceAfter.toLocaleString()}</span>
            </div>

            <div class="row">
              <strong>TOTAL CURRENT BALANCE</strong>
              <span>$${latestTransaction.currentBalance.toLocaleString()}</span>
            </div>

          </div>

          <div class="footer">
            THANK YOU FOR CHOOSING
            <br />
            RCS FOCUS FINANCE
          </div>

        </div>

      </body>
      </html>
    `);

    receiptWindow.document.close();

    receiptWindow.print();
  };

  if (processing) {
    return (
      <div className="finance-processing-overlay">
        <div className="finance-processing-card">
          <div className="finance-loader-wrapper">
            <div className="finance-loader-ring"></div>

            <div className="finance-loader-logo">
              <img
                src={logo}
                alt="RCS Logo"
              />
            </div>
          </div>

          <h2>Processing Transaction</h2>

          <p>
            Securing investor ledger updates and
            recalculating balances...
          </p>
        </div>
      </div>
    );
  }

if (success) {
  return (
    <TransactionSuccessModal
      transaction={latestTransaction}
      onClose={() => {
        setSuccess(false);

        /* ✅ refresh AFTER modal closes */
        refreshInvestors();

        onClose();
      }}
    />
  );
}
  return (
    <div className="modern-transaction-overlay">
      <div className="modern-transaction-modal">
        <button
          className="modern-transaction-close"
          onClick={onClose}
        >
          <X size={22} />
        </button>

        {/* LEFT */}

        <div className="modern-transaction-left">
          <div className="modern-transaction-tag">
            <Wallet size={14} />
            Finance Transaction
          </div>

          <h1>
            Process
            <br />
            Transaction
          </h1>

          <p>
            Deposit or withdraw investor funds, PLEASE ENSURE CORRECT AMOUNTS ARE ENTERED, TRANSACTIONS ARE NONE REVERSABLE!!
          </p>

          <div className="modern-transaction-form">
            <label>Select Investor</label>

            <Select
              classNamePrefix="finance-rs"
              options={investors}
              value={selectedInvestor}
              onChange={(selectedOption) => {
                setSelectedInvestor(
                  selectedOption || null
                );

                setSelectedInvestorData(
                  selectedOption?.investorData ||
                    null
                );
              }}
              placeholder="Search investor..."
              isSearchable
              isClearable
            />

            <label>Transaction Type</label>

            <div className="modern-transaction-type-grid">
              <button
                className={`transaction-type-btn ${
                  transactionType === "Deposit"
                    ? "active-deposit"
                    : ""
                }`}
                onClick={() =>
                  setTransactionType("Deposit")
                }
              >
                <ArrowDownCircle size={18} />
                Deposit
              </button>

              <button
                className={`transaction-type-btn ${
                  transactionType === "Withdrawal"
                    ? "active-withdrawal"
                    : ""
                }`}
                onClick={() =>
                  setTransactionType(
                    "Withdrawal"
                  )
                }
              >
                <ArrowUpCircle size={18} />
                Withdrawal
              </button>
            </div>

            <label>Transaction Amount</label>

            <input
              type="number"
              value={amount}
              onChange={(e) =>
                setAmount(e.target.value)
              }
              placeholder="Enter amount"
            />

            <label>Transaction Date</label>

            <DatePicker
              selected={transactionDate}
              onChange={(date) =>
                setTransactionDate(date)
              }
              dateFormat="MM/dd/yyyy"
              className="modern-datepicker"
            />

            <div className="modern-transaction-actions">
              <button
                className="modern-confirm-btn"
                onClick={handleTransaction}
              >
                Confirm Transaction
              </button>

              <button
                className="modern-cancel-btn"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT */}

        <div className="modern-transaction-right">
          <div className="modern-live-card">
            <div className="modern-live-header">
              <div>
                <h3>Live Transaction Preview</h3>

                <span>
                  Real-time balance updates, Please ensure accurate figures before confirming transaction, TRANSACTIONS ARE NONE REVERSABLE!
                </span>
              </div>

              <Activity size={22} />
            </div>

            {selectedInvestorData ? (
              <>
                <div className="modern-investor-preview">
                  <div className="preview-avatar">
                    {selectedInvestorData?.name?.charAt(
                      0
                    )}
                  </div>

                  <div>
                    <h4>
                      {selectedInvestorData?.name}
                    </h4>

                    <span>
                      {
                        selectedInvestorData?.account_number
                      }
                    </span>
                  </div>
                </div>

                <div className="modern-preview-grid">
                  <div className="preview-item">
                    <User size={18} />
                    <div>
                      <span>Account Type</span>
                      <strong>
                        {
                          selectedInvestorData?.account_type
                        }
                      </strong>
                    </div>
                  </div>

                  <div className="preview-item">
                    <TrendingUp size={18} />
                    <div>
                      <span>ROI</span>
                      <strong>
                        {parseFloat(
                          selectedInvestorData?.roi ||
                            0
                        ).toFixed(2)}
                        %
                      </strong>
                    </div>
                  </div>

                  <div className="preview-item">
                    <ShieldCheck size={18} />
                    <div>
                      <span>
                        Available Balance
                      </span>
                      <strong>
                        $
                        {balanceBefore.toLocaleString()}
                      </strong>
                    </div>
                  </div>

                  <div className="preview-item">
                    <CalendarDays size={18} />
                    <div>
                      <span>
                        Current Balance
                      </span>
                      <strong>
                        $
                        {currentBalance.toLocaleString()}
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="modern-balance-calculator">
                  <div className="calc-row">
                    <span>
                      Balance Before
                    </span>

                    <strong>
                      $
                      {balanceBefore.toLocaleString()}
                    </strong>
                  </div>

                  <div className="calc-row">
                    <span>
                      Transaction Amount
                    </span>

                    <strong
                      className={
                        transactionType ===
                        "Deposit"
                          ? "green"
                          : "red"
                      }
                    >
                      {transactionType ===
                      "Deposit"
                        ? "+"
                        : "-"}
                      $
                      {amountValue.toLocaleString()}
                    </strong>
                  </div>

                  <div className="calc-divider"></div>

                  <div className="calc-row total">
                    <span>Balance After</span>

                    <strong>
                      $
                      {balanceAfter.toLocaleString()}
                    </strong>
                  </div>
                </div>
              </>
            ) : (
              <div className="modern-empty-preview">
                Select an investor to preview
                transaction details.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default TransactionModal;